import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import 'flatpickr/dist/l10n/fr.js'

document.addEventListener('turbo:load', () => {
  let altFormat = ''

  if (document.querySelector('html').getAttribute('lang') === 'fr') {
    altFormat = 'd/m/Y'
    flatpickr.localize(flatpickr.l10ns.fr)
  } else {
    altFormat = 'Y/m/d'
    flatpickr.localize(flatpickr.l10ns.default)
  }

  flatpickr('.flatpickr-date', {
    altInput: true,
    altFormat: altFormat,
    dateFormat: 'Y-m-d',
    defaultDate: 'today',
  })

  let calendarIcon = document.querySelector('.calendar-icon')

  if (calendarIcon) {
    calendarIcon.addEventListener('click', (e) => {
      e.target.parentElement.querySelector('input:not([type="hidden"])').focus()
    })
  }
})
